import * as types from '../../../constants/quote/step00'

const initialState = {
    policyCategories: {
        isLoading: false,
        errors: null,
        data: [],
    },
    policyTypes: {
        isLoading: false,
        errors: null,
        data: [],
    },
    countries: {
        isLoading: false,
        errors: null,
        data: [],
    },
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_POLICY_CATEGORIES_REQUEST:
            return {
                ...state,
                policyCategories: {
                    errors: null,
                    data: [],
                    isLoading: true,
                },
            }
        case types.FETCH_POLICY_CATEGORIES_SUCCESS:
            return {
                ...state,
                policyCategories: {
                    ...state.policyCategories,
                    data: action.payload,
                },
            }
        case types.FETCH_POLICY_CATEGORIES_FAILURE:
            return {
                ...state,
                policyCategories: {
                    ...state.policyCategories,
                    errors: action.payload,
                },
            }
        case types.FETCH_POLICY_CATEGORIES_FULFILL:
            return {
                ...state,
                policyCategories: {
                    ...state.policyCategories,
                    isLoading: false,
                },
            }
        case types.FETCH_POLICY_TYPES_REQUEST:
            return {
                ...state,
                policyTypes: {
                    errors: null,
                    data: [],
                    isLoading: true,
                },
            }
        case types.FETCH_POLICY_TYPES_SUCCESS:
            return {
                ...state,
                policyTypes: {
                    ...state.policyTypes,
                    data: action.payload,
                },
            }
        case types.FETCH_POLICY_TYPES_FAILURE:
            return {
                ...state,
                policyTypes: {
                    ...state.policyTypes,
                    errors: action.payload,
                },
            }
        case types.FETCH_POLICY_TYPES_FULFILL:
            return {
                ...state,
                policyTypes: {
                    ...state.policyTypes,
                    isLoading: false,
                },
            }
        case types.FETCH_COUNTRIES_REQUEST:
            return {
                ...state,
                countries: {
                    errors: null,
                    data: [],
                    isLoading: true,
                },
            }
        case types.FETCH_COUNTRIES_SUCCESS:
            return {
                ...state,
                countries: {
                    ...state.countries,
                    data: action.payload,
                },
            }
        case types.FETCH_COUNTRIES_FAILURE:
            return {
                ...state,
                countries: {
                    ...state.countries,
                    errors: action.payload,
                },
            }
        case types.FETCH_COUNTRIES_FULFILL:
            return {
                ...state,
                countries: {
                    ...state.countries,
                    isLoading: false,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote/step00/index.ts